// extracted by mini-css-extract-plugin
export default {"menuBlock":"gG-z","title":"hG-z","nav":"iG-z","flexCell":"jG-z","facetLink":"kG-z"};